
import Vue from 'vue';


// 自定义指令 按钮防抖
Vue.directive('throttle', {
  bind: (el, binding) => {
    let throttleTime = binding.value; // 防抖时间
    if (!throttleTime) { // 用户若不设置防抖时间，则默认1s
      throttleTime = 1000;
    }
    let cbFun;
    el.addEventListener('click', event => {
      if (!cbFun) { // 第一次执行
        cbFun = setTimeout(() => {
          cbFun = null;
        }, throttleTime);
      } else {
        event && event.stopImmediatePropagation();
      }
    }, true);
  },
})

// 数字后面添加.00 span使用
Vue.directive('floating-point-span', {
  update: (el, binding) => {
    if (binding.value != null && binding.value != '') binding.value = +binding.value
    if (typeof binding.value == "number") {
      el.innerText = (binding.value == 0 ? '0.00' : parseFloat(binding.value).toFixed(2))
    } else {
      el.innerText = binding.value ? binding.value : ''
    }
  }
})